export const initial = {};

export function update(state, payload) {
    const placement = payload.placement;
    return {...state, [placement]: {...payload, placement: placement}};
}



// WEBPACK FOOTER //
// ./app/reducers/promo-message.js